import { Text } from '@cinch-labs/design-system'

type CopyrightProps = {
  year: number | undefined
}

export const Copyright = ({ year }: CopyrightProps) => (
  <Text fontSizeFixed="xs" color="pureWhite">
    &copy; {year ?? ''} Cinch Cars Limited. All rights reserved.
  </Text>
)
